<ul #scrollContainer>
    <ng-container *ngFor="let post of posts">
        <li class="wpee-feed-list" *ngIf="getUsername(post) && !this.posts_shimmer">
            <header class="feed-header d-flex align-center">
                <div class="feed-profile-img">
                    <a [routerLink]="checkProfile(getUsername(post))">
                        <img [src]="getProfilePic(post) || 'default-placeholder.png'" alt="Profile Picture">
                    </a>
                </div>
                <div class="feed-title-wrap">
                    <h3 class="feed-title">
                        <strong><a [routerLink]="checkProfile(getUsername(post))">{{ getUsername(post)
                                }}</a></strong>
                        just added new <strong>{{ getName(post?.postCategory?.name) }}.</strong>
                    </h3>
                    <time class="time">{{ post?.updatedAt | date:'dd MMM' }}</time>
                </div>
            </header>
            <section class="feed-content feed-status-content">
                <p class="status-box" *ngIf="post?.postType?.name === 'text'">
                    <span class="status-wrap">{{ post?.textMessages }}</span>
                </p>
                <div class="img_content" *ngIf="getCategoryImage(post)" (click)="openImageModal(getCategoryImage(post))">
                    <img [src]="getCategoryImage(post)">
                </div>
            </section>
        </li>
    </ng-container>
    <li *ngIf="this.shimmer" class="post shine"></li>
    <li *ngIf="this.shimmer" class="post shine"></li>
    <li *ngIf="!shimmer && posts.length == 0" class="t-a-c no-feeds">
       No feeds
    </li>
</ul>